define('views/modules/calendar/animated-session/tags/manager/custom-tags-manager-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/viewport',
    'services/layout',
    // Views
    'views/parts/panel/base-panel',
    'views/modules/calendar/animated-session/tags/manager/custom-tags-manager-content',
    'views/modules/calendar/animated-session/tags/manager/edit/tag-edit-panel',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    Viewport,
    LayoutState,
    // views
    VBasePanel,
    VCustomTagsManagerContent,
    VTagEditPanel
) {

    var VCustomTagsManagerPanel = VBasePanel.extend({
        header: {
            title: "calendar:Custom tags",
            subtitle: "calendar:Adding/Modify a custom tag",
        },
        tabs: [{ id: 'manage', title: 'Manage', active: true }],
        content: {
            manage: VCustomTagsManagerContent
        },
        defaultView: 'manage',

        initialize: function(opt) {
            opt = opt || {};
            var manage = this.getView('manage', {
                model: this.model,
                group: opt.group,
            });
            this.listenTo(this, { 'toggle': this.onOpen });
        },

        ////////////
        // events //
        ///////////

        // onExpandPanel: function() {
        //     if (LayoutState.isFull('info')) {
        //         LayoutState.toggleInfoFull();
        //     } else {
        //         this.view.manage.toggleAnimationPanel(true);
        //     }
        // },

    });

    return VCustomTagsManagerPanel;
});

